/* eslint-disable react/jsx-indent */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Button from '../buttons/Button';
import Date from '../partials/Date';
import Image from '../partials/Image';
import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/cards/projection.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    vertical: PropTypes.bool,
    getUrlFromItem: PropTypes.func,
    className: PropTypes.string,
};

function ProjectionCard({
    item = null,
    vertical = false,
    getUrlFromItem = null,
    className = null,
    ...props
}) {
    const {
        title = null,
        startDate = null,
        url = null,
        venues = null,
        films = null,
        image = null,
    } = item || {};

    const [firstVenue = null] = venues || [];
    const finalUrl = useMemo(
        () => (getUrlFromItem !== null ? getUrlFromItem(item) : url),
        [url, getUrlFromItem],
    );
    const filmNames = useMemo(
        () =>
            (films || []).reduce((acc, film) => {
                const { title: filmTitle = null } = film || {};
                if (filmTitle !== null) {
                    return `${acc}${acc.length > 0 ? ' + ' : ''}${filmTitle}`;
                }
                return acc;
            }, ''),
        [films],
    );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.vertical]: vertical,
                    [className]: className !== null,
                },
            ])}
            href={finalUrl}
            {...props}
        >
            {image !== null ? (
                <Image
                    className={styles.image}
                    image={image}
                    size="medium"
                    filtered
                    filteredHover={url !== null}
                    rounded
                    square
                />
            ) : null}

            <div className={styles.content}>
                {startDate !== null ? (
                    <Text className={styles.date}>
                        <Date date={startDate} />
                    </Text>
                ) : null}
                {title !== null && filmNames === null ? (
                    <Text className={styles.title}>{title}</Text>
                ) : null}
                {filmNames !== null ? (
                    <Title className={styles.films} size="small">
                        {filmNames}
                    </Title>
                ) : null}
                {firstVenue !== null ? (
                    <Text className={styles.description}>{firstVenue?.nameWithCity}</Text>
                ) : null}
            </div>
        </Button>
    );
}

ProjectionCard.propTypes = propTypes;

export default ProjectionCard;
